import React from "react";

const SharesBuyBack = () => {
  return <div>SharesBuyBack</div>;
};

export default SharesBuyBack;
